<template>
    <div class="coin-rebase-box">
        <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top: 20px">
            <el-tab-pane label="变基列表" name="REBASELIST"></el-tab-pane>
            <el-tab-pane label="生成变基" name="CREATREBASE"></el-tab-pane>
            <el-tab-pane label="确认变基" name="GRANTREBASE"></el-tab-pane>
            <el-tab-pane label="删除变基" name="DELETEREBASE"></el-tab-pane>
        </el-tabs>
        <el-form :inline="true" style="margin-top: 20px;" class="header-box">
            <el-form-item label="币种">
                <el-input v-model="serchInfo.coinType" placeholder="币种"></el-input>
            </el-form-item>

            <el-form-item label="新基数" v-if="activeName=='CREATREBASE'">
                <el-input v-model="serchInfo.newSupply" placeholder="新基数"></el-input>
            </el-form-item>

            <el-form-item label="	老基数" v-if="activeName=='CREATREBASE'">
                <el-input v-model="serchInfo.oldSupply" placeholder="老基数"></el-input>
            </el-form-item>

            <el-form-item label="变基时间">
                <el-date-picker v-model="serchInfo.rebaseTime"
                                :picker-options="activeName=='CREATREBASE'?pickerOptions:pickerOptionsFalse"
                                value-format="timestamp"
                                type="datetime" :default-value="new Date()" placeholder="请选择日期(不填默认为当前日期)"
                                style="width: 300px">
                </el-date-picker>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="search()"
                           v-if="activeName=='REBASELIST' || activeName=='GRANTREBASE' || activeName=='DELETEREBASE'">搜索
                </el-button>
                <el-button type="success" @click="createRebase()" v-if="activeName=='CREATREBASE'">生成变基</el-button>
                <el-button type="danger" @click="grantRebase()" v-if="activeName=='GRANTREBASE'">确认变基</el-button>
                <el-button type="danger" @click="deleteRebase()" v-if="activeName=='DELETEREBASE'">删除变基</el-button>
            </el-form-item>
        </el-form>

        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>变基信息</span>
            </div>
            <div style="width: 100%">
                <el-form :inline="true" class="header-box">
                    <el-form-item label="币种:" style="width: 350px">
                        <span>{{detail.coinType}}</span>
                    </el-form-item>
                    <el-form-item label="变基时间:" style="width: 350px">
                        <span>{{ detail.rebaseTime | moment }}</span>
                    </el-form-item>
                    <el-form-item label="新基数:" style="width: 350px">
                        <span>{{ detail.newSupply}}</span>
                    </el-form-item>
                    <el-form-item label="老基数:" style="width: 350px">
                        <span>{{ detail.oldSupply}}</span>
                    </el-form-item>
                    <el-form-item label="变基前可用总量:" style="width: 350px">
                        <span>{{ detail.beforeAvAmount}}</span>
                    </el-form-item>
                    <el-form-item label="变基后可用总量:" style="width: 350px">
                        <span>{{ detail.afterAvAmount}}</span>
                    </el-form-item>
                    <el-form-item label="当前实际可用总量:" style="width: 350px">
                        <span>{{ detail.currentAvAmount}}</span>
                    </el-form-item>
                    <el-form-item label="可用总改变量:" style="width: 350px">
                        <span>{{ detail.changeAvAmount}}</span>
                    </el-form-item>
                    <el-form-item label="对账账户可用余额:" style="width: 350px">
                        <span>{{ detail.reconciliationAccountAvAmount}}</span>
                    </el-form-item>
                    <el-form-item label="变基前冻结总量:" style="width: 350px">
                        <span>{{ detail.beforeFrAmount}}</span>
                    </el-form-item>
                    <el-form-item label="变基后冻结总量:" style="width: 350px">
                        <span>{{ detail.afterFrAmount}}</span>
                    </el-form-item>
                    <el-form-item label="当前实际冻结总量:" style="width: 350px">
                        <span>{{ detail.currentFrAmount}}</span>
                    </el-form-item>
                    <el-form-item label="冻结总改变量:" style="width: 350px">
                        <span>{{ detail.changeFrAmount}}</span>
                    </el-form-item>
                    <el-form-item label="对账账户冻结余额:" style="width: 350px">
                        <span>{{ detail.reconciliationAccountFrAmount}}</span>
                    </el-form-item>
                    <el-form-item label="总数据行数:" style="width: 350px">
                        <span>{{ detail.dataRowTotal}}</span>
                    </el-form-item>
                    <el-form-item label="待转账行数:" style="width: 350px">
                        <span>{{ detail.waitTransferRows}}</span>
                    </el-form-item>
                    <el-form-item label="已转账行数:" style="width: 350px">
                        <span>{{ detail.doneRows}}</span>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>

        <el-table style="margin-top: 20px" :data="listInfo" :row-key="() => Math.random()">
            <el-table-column label="记录ID" prop="id"></el-table-column>
            <el-table-column label="用户账户" prop="userId"></el-table-column>
            <el-table-column label="币种" prop="coinType"></el-table-column>
            <el-table-column label="当前可用余额" prop="currentCoinAmount"></el-table-column>
            <el-table-column label="当前冻结余额" prop="currentCoinFroze"></el-table-column>
            <el-table-column label="新基数" prop="newSupply"></el-table-column>
            <el-table-column label="老基数" prop="oldSupply"></el-table-column>
            <el-table-column label="可用余额变更" prop="avChangeAmount"></el-table-column>
            <el-table-column label="冻结余额变更" prop="frChangeAmount"></el-table-column>
            <el-table-column label="变基时间" prop="rebaseTime">
                <template slot-scope="scope">{{ scope.row.rebaseTime | moment }}</template>
            </el-table-column>
            <el-table-column label="状态" prop="status">
                <template slot-scope="scope">
                    <span v-if="scope.row.status == 1">创建</span>
                    <span v-if="scope.row.status == 2">转账</span>
                    <span v-else-if="scope.row.status == 3">确认变基(待转账)</span>
                </template>
            </el-table-column>
        </el-table>

        <div class="footer-box" style="margin-top: 20px">
            <el-pagination
                    @size-change="sizeChange"
                    @current-change="pageChange"
                    :current-page="serchInfo.page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="serchInfo.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import "./store";
    import api from "./api";
    import {mapActions, mapState} from "vuex";

    export default {
        name: "CoinRebase",
        data() {
            return {
                listInfo: [], //数据列表
                total: 0, //总条数
                detail: {}, //变基详情
                serchInfo: {
                    coinType: "",
                    rebaseTime: "",
                    newSupply: "",
                    oldSupply: "",
                    page: 1,
                    size: 10
                },
                activeName: "REBASELIST",
                pickerOptions: {
                    disabledDate(time) {
                        return (time.getTime() < (Date.now() - (3 * 24 * 60 * 60 * 1000)) || time.getTime() > Date.now());
                    }
                },
                pickerOptionsFalse: {
                    disabledDate(time) {
                        return false;
                    }
                }
            };
        },
        created() {
            // this.getList(this.serchInfo);
        },
        methods: {
            search() {
                this.serchInfo.page = 1;
                this.getList(this.serchInfo)
                this.getDetail(this.serchInfo)
            },
            getList(query) {
                if (this.serchInfo.coinType == "") {
                    this.$message.success("请输入币种");
                    return;
                }
                api.list(query).then(({data}) => {
                    this.total = data.totalCount;
                    this.listInfo = data.list;
                })
            },
            getDetail(query) {
                if (this.serchInfo.coinType == "") {
                    this.$message.success("请输入币种");
                    return;
                }
                api.info(query).then(({data}) => {
                    this.detail = data;
                })
            },
            sizeChange(val) {
                this.serchInfo.size = val;
                this.getList(this.serchInfo);
                this.getDetail(this.serchInfo)
            },
            pageChange(val) {
                this.serchInfo.page = val;
                this.getList(this.serchInfo);
                this.getDetail(this.serchInfo)
            },
            createRebase() {
                if (this.serchInfo.coinType == "") {
                    this.$message.success("请输入币种");
                    return;
                }
                if (this.serchInfo.newSupply == "") {
                    this.$message.success("请输入新基数");
                    return;
                }
                if (this.serchInfo.oldSupply == "") {
                    this.$message.success("请输入老基数");
                    return;
                }
                api.create(this.serchInfo).then(res => {
                    if (!res.code) {
                        this.$message.success("生成成功");
                        this.getList(this.serchInfo);
                        this.getDetail(this.serchInfo)
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            deleteRebase() {
                if (this.serchInfo.coinType == "") {
                    this.$message.success("请输入币种");
                    return;
                }
                api.delete(this.serchInfo).then(res => {
                    if (!res.code) {
                        this.$message.success("删除成功");
                        this.getList(this.serchInfo);
                        this.getDetail(this.serchInfo)
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            grantRebase() {
                if (this.serchInfo.coinType == "") {
                    this.$message.success("请输入币种");
                    return;
                }
                api.confirmAndChangeBalance(this.serchInfo).then(res => {
                    if (!res.code) {
                        this.$message.success("确认成功");
                        this.getList(this.serchInfo);
                        this.getDetail(this.serchInfo)
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            handleClick() {
                this.listInfo = []; //数据列表
                this.total = 0; //总条数
                this.detail = {};
                this.serchInfo = {
                    coinType: "",
                    rebaseTime: "",
                    newSupply: "",
                    oldSupply: "",
                    page: 1,
                    size: 10
                }
            }
        }
    };
</script>

<style lang="less">
    .coin-rebase-box {
        .header-box {
            width: 90%;
            // border: 1px solid #cccccc;
            padding: 16px;
            .el-form-item {
                padding-right: 30px;
            }
        }

        .clearfix:before,
        .clearfix:after {
            display: table;
            content: "";
        }
        .clearfix:after {
            clear: both
        }

        .box-card {
            width: 480px;
            width: 100%;
        }
    }
</style>
